export interface CsSegmentButtonInterface {
  deselect(): void;
  select(): void;
  getValue(): any;
}

export class CsSegmentButtonBase implements CsSegmentButtonInterface {
  select(): void {
    throw new Error("Method not implemented.");
  }
  getValue(): any {
    throw new Error("Method not implemented.");
  }
  deselect(): void {
    throw new Error("Method not implemented.");
  }

}
